export default "__VITE_ASSET__646b467c__"